import * as React from "react";
function SvgLabeledHrLine(props, svgRef) {
  return <svg xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><line x1="0%" x2="100%" y1="45%" y2="45%" strokeWidth="0.05em" style={{
      stroke: "var(--svg-color, #fff)"
    }} /><line x1="100%" x2="100%" y1="0%" y2="100%" strokeWidth="0.05em" style={{
      stroke: "var(--svg-color, #fff)"
    }} /></svg>;
}
const ForwardRef = React.forwardRef(SvgLabeledHrLine);
export default __webpack_public_path__ + "src/openspace/assets/svg/labeled-hr-line.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/openspace/assets/svg/labeled-hr-line_0.5x.svg",
  "1x": __webpack_public_path__ + "src/openspace/assets/svg/labeled-hr-line_1x.svg",
  "2x": __webpack_public_path__ + "src/openspace/assets/svg/labeled-hr-line_2x.svg",
  "3x": __webpack_public_path__ + "src/openspace/assets/svg/labeled-hr-line_3x.svg",
  "4x": __webpack_public_path__ + "src/openspace/assets/svg/labeled-hr-line_4x.svg"
};
export { ForwardRef as ReactComponent };